var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"c-d_heading"},[_c('div',{staticClass:"c-d_heading__left"},[_vm._t("default")],2),_vm._v(" "),(_vm.backHref)?_c('div',{staticClass:"c-d_heading__right"},[_c('v-btn',{staticClass:"c-d_heading__back",attrs:{"to":_vm.backHref,"type":"back"}},[_vm._v("\n            Wróć\n        ")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }